import { PERMISSIONS } from '$app/constants/common'
import { ROUTE_NAMES, RouteNames } from '$router/config'
import {
  Folders,
  GalleryHorizontalEnd,
  GitFork,
  Globe2,
  Home,
  Key,
  ListTree,
  LucideIcon,
  Network,
  Settings,
  Settings2,
  ShieldCheck,
  UserRoundCheck,
  Users2,
  UsersRound
} from 'lucide-react'

export type MENU_ITEM = {
  name: string
  path: RouteNames
  Icon: LucideIcon
  subPath?: RouteNames[]
  permissions: PERMISSIONS[]
}

export type MENU = {
  title: string
  menus: MENU_ITEM[]
}

export type STATIC_MENU_ITEM = {
  name: string
  path: string
  Icon: LucideIcon
  subPath?: RouteNames[]
  permissions: PERMISSIONS[]
}

export const APP_SIDE_MENUS: MENU[] = [
  {
    title: '',
    menus: [
      {
        name: 'Home',
        path: ROUTE_NAMES.APP_HOME,
        Icon: Home,
        permissions: [PERMISSIONS.APPLICATION_VIEW_BASIC]
      },
      {
        name: 'Basic Setting',
        path: ROUTE_NAMES.APP_BASIC_SETTING,
        Icon: Settings2,
        permissions: [PERMISSIONS.APPLICATION_VIEW_BASIC]
      },
      {
        name: 'Advanced Setting',
        path: ROUTE_NAMES.APP_ADVANCED_SETTING,
        Icon: Settings,
        permissions: [PERMISSIONS.APPLICATION_VIEW_ADVANCED]
      },
      {
        name: 'Webhooks',
        path: ROUTE_NAMES.APP_WEBHOOK_SETTING,
        Icon: GitFork,
        permissions: [PERMISSIONS.APPLICATION_MANAGE_WEBHOOKS]
      },
      {
        name: 'Launchpad',
        path: ROUTE_NAMES.APP_LAUNCHPAD_SETTING,
        Icon: GalleryHorizontalEnd,
        permissions: [PERMISSIONS.APPLICATION_VIEW_LAUNCHPAD]
      },
      {
        name: 'Group',
        path: ROUTE_NAMES.APP_GROUPS,
        Icon: Folders,
        subPath: [
          ROUTE_NAMES.APP_GROUP_CREATE,
          ROUTE_NAMES.APP_GROUP_DETAIL,
          ROUTE_NAMES.APP_GROUP_EDIT
        ],
        permissions: [PERMISSIONS.APPLICATION_VIEW_GROUP]
      },
      {
        name: 'Users',
        path: ROUTE_NAMES.APP_USERS,
        Icon: Users2,
        subPath: [ROUTE_NAMES.APP_USER_DETAIL],
        permissions: [PERMISSIONS.APPLICATION_USER_VIEW]
      },
      {
        name: 'Roles',
        path: ROUTE_NAMES.APP_ROLES,
        Icon: ListTree,
        subPath: [
          ROUTE_NAMES.APP_ROLE_CREATE,
          ROUTE_NAMES.APP_ROLE_DETAIL,
          ROUTE_NAMES.APP_ROLE_EDIT
        ],
        permissions: [PERMISSIONS.APPLICATION_ROLE_VIEW]
      },
      {
        name: 'Permissions',
        path: ROUTE_NAMES.APP_PERMISSIONS,
        Icon: Network,
        subPath: [
          ROUTE_NAMES.APP_PERMISSION_CREATE,
          ROUTE_NAMES.APP_PERMISSION_DETAIL,
          ROUTE_NAMES.APP_PERMISSION_EDIT
        ],
        permissions: [PERMISSIONS.APPLICATION_PERMISSION_VIEW]
      }
    ]
  }
]

export const GLOBAL_SETTING_SIDE_MENUS: MENU[] = [
  {
    title: '',
    menus: [
      {
        name: 'Countries',
        path: ROUTE_NAMES.COUNTRIES,
        Icon: Globe2,
        subPath: [ROUTE_NAMES.COUNTRY_CREATE, ROUTE_NAMES.COUNTRY_EDIT],
        permissions: [PERMISSIONS.COUNTRY_VIEW]
      }
    ]
  },
  {
    title: 'Security',
    menus: [
      {
        name: 'Password Policy',
        path: ROUTE_NAMES.PASSWORD_POLICY,
        Icon: Key,
        subPath: [],
        permissions: []
      },
      {
        name: 'Attack Protection',
        path: ROUTE_NAMES.ATTACK_PROTECTION,
        Icon: ShieldCheck,
        subPath: [],
        permissions: []
      }
    ]
  }
]

export const ASSIGN_ROLES_VALUE = {
  ALL: 'all-roles',
  SELECTED: 'selected-roles'
} as const

export const ASSIGN_ROLES_SIDE_MENUS: STATIC_MENU_ITEM[] = [
  {
    name: 'All roles',
    path: ASSIGN_ROLES_VALUE.ALL,
    Icon: UsersRound,
    permissions: []
  },
  {
    name: 'Selected roles',
    path: ASSIGN_ROLES_VALUE.SELECTED,
    Icon: UserRoundCheck,
    permissions: []
  }
]
